import type { ConfirmRecapAction } from "../types/action";
import type { ValidationResult } from "../types/common";
import type { HorrorRaceState } from "../types/game-state";

export function validateConfirmRecap(
  state: HorrorRaceState,
  action: ConfirmRecapAction,
): ValidationResult {
  if (state.phase !== "RACE_SCORING") {
    return { valid: false, error: "Not in race scoring phase" };
  }

  const player = state.players.find((p) => p.id === action.playerId);
  if (!player) {
    return { valid: false, error: "Player not found" };
  }

  if (player.hasConfirmedRecap) {
    return { valid: false, error: "Player has already confirmed the recap" };
  }

  return { valid: true };
}
